// Default color palette
export const defaultPalette = [
  "#e67e00", // Orange
  "#4695ff", // Blue
  "#00d27a", // Green
  "#727cf5", // Indigo
  "#f5803e", // Light orange
  "#6b5eae", // Violet
  "#02a8b5", // Turquoise
  "#e63757", // Red
  "#ffa333", // Light orange
  "#344050", // Dark gray
  "#9da9bb", // Light gray
];

// Map of client color palettes by group ID (Azure Entra ID)
const CSA = Object.freeze(["#3b5561", "#e67e00", "#e94e1b", "#27bcfd"]);
const CNP = Object.freeze(["#112369", "#E00371", "#00B4AC", "#737DA7"]);

export const clientPalettes = {
  // CSA
  "f8531fca-2b27-4652-9392-1a9bceb1060c": CSA, // Test
  "acb86f80-1168-455a-93f3-8d738f9e98f3": CSA, // Prod

  // CNP_ASSURANCES
  "50a4f21b-ae3b-4a09-bfcd-f488b3053923": CNP, // Test
  "ba401503-38f7-41a4-a715-1a5dbc6360f9": CNP, // Prod
};

export const getClientPalette = (id) => {
  return clientPalettes[id] || defaultPalette;
};
